package modysy.menu

import modysy.InputHandler
import modysy.gamestate.GameStateManager
import org.scalajs.dom

abstract class AbstractMenu(
    inputs: InputHandler,
    width: Double,
    height: Double
) {

  var buttons: List[AbstractButton] = List()

  def render(ctx: dom.CanvasRenderingContext2D): Unit = {
    buttons.foreach(b => {
      b.render(ctx)
    })
  }

  def update(): Unit = {
    buttons.foreach(b => {
      b.update(inputs)
    })
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/menu/AbstractMenu.scala